import { Accordion, AccordionSummary, AccordionDetails, Box } from "@mui/material";
import ErrorIcon from "@mui/icons-material/Error";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import KeyboardArrowDownOutlinedIcon from "@mui/icons-material/KeyboardArrowDownOutlined";
import KeyboardArrowUpOutlinedIcon from "@mui/icons-material/KeyboardArrowUpOutlined";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import AddIcon from "@mui/icons-material/Add";
import { memo, useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { useDispatch } from "react-redux";
import { actionSuccess, hideLoader, showLoader } from "middleware/actions/utilityAction";
import { deleteProductSPecification, fetchProductSpecification } from "middleware/services/productApi";
import { COMMON_ACCESS_ACTION } from "constants";
import ThreeDotMenu from "app/components/threeDotMenu";
import { showAlertBox } from "middleware/actions/alertBoxAction";

const TechnicalSpecs = (props) => {
  const { accessRights: aR, productId } = props;
  const split_url = props.location.pathname.split("/");
  split_url.pop();
  const [expandedAccordions, setExpandedAccordions] = useState({
    technicalSpecs: false,
  });
  const [specificationData, setSpecificationData] = useState([]);

  /* Common access */
  const accessPermissionAdd = props?.interfaceActionAccess?.includes(COMMON_ACCESS_ACTION.ADD_NEW);
  const accessPermissionEdit = props?.interfaceActionAccess?.includes(COMMON_ACCESS_ACTION.EDIT);
  const accessPermissionDelete = props?.interfaceActionAccess?.includes(COMMON_ACCESS_ACTION.DELETE);
  const accessPermissionSubmit = props?.interfaceActionAccess?.includes(COMMON_ACCESS_ACTION.SUBMIT);
  const dispatch = useDispatch();
  const history = useHistory();
  const showLoaderGrid = () => dispatch(showLoader());
  const hideLoaderGrid = () => dispatch(hideLoader());

  const handleAccordionChange = (panel) => {
    setExpandedAccordions((prev) => ({
      ...prev,
      [panel]: !expandedAccordions[panel],
    }));
  };

  const handleFetchListing = async (params) => {
    try {
      const response = await fetchProductSpecification(productId, params);
      if (response) {
        setSpecificationData(response.data?.data || []);
      }
    } catch (err) {
      dispatch(actionError(err?.data?.message || "Something went wrong."));
    } finally {
      hideLoader();
      hideLoaderGrid();
    }
  };

  const handleDeleteSpecification = async (id) => {
    dispatch(
      showAlertBox({
        okCallback: async () => {
          await deleteProductSPecification(productId, id)
            .then(() => {
              dispatch(actionSuccess("Technical specification deleted successfully."));
            })
            .catch((err) => {
              dispatch(actionError(err.data.message || "Something went wrong."));
            });
          await handleFetchListing();
        },
      })
    );
  };

  useEffect(() => {
    if (productId) {
      showLoaderGrid();
      handleFetchListing();
    }

    return () => hideLoaderGrid();
  }, [productId]);

  return (
    <div className="gennx-content-wrapper padding-bottom-100i">
      <div className="h-full flex flex-col m-3 w-auto border border-[#DBDBDD] overflow-y-auto">
        <Accordion
          sx={{
            backgroundColor: "white",
            margin: "0 !important",
            border: "none",
            borderRadius: "0 !important",
            boxShadow: "none",
            "&.Mui-expanded": {
              margin: "0 !important",
              borderTop: "1px solid #e0e0e0",
            },
            "&:before": {
              display: "none",
            },
          }}
          className="!m-0"
          expanded={specificationData?.length > 0 && expandedAccordions["technicalSpecs"]}
          onChange={() => handleAccordionChange("technicalSpecs")}
        >
          <AccordionSummary
            className="w-full"
            sx={{
              flexDirection: "row-reverse",
              "&.Mui-expanded": {
                margin: "0",
                minHeight: "48px",
              },
              "& .MuiAccordionSummary-content": {
                flexGrow: 1,
                margin: 0,
                alignItems: "center",
              },
              "& .MuiAccordionSummary-expandIconWrapper": {
                marginLeft: "auto",
              },
              height: "60px",
              padding: "1rem !important",
            }}
            aria-controls="panel1bh-content"
            id="panel1bh-header"
          >
            <Box className="w-full flex flex-col">
              <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                <Box sx={{ display: "flex", alignItems: "center", flexGrow: 1 }}>
                  {false ? (
                    <ErrorIcon color="warning" />
                  ) : (
                    <CheckCircleIcon
                      sx={{
                        color: specificationData?.length > 0 ? "#0CB963 !important" : "action.disabled",
                        fontSize: "32px !important",
                      }}
                    />
                  )}
                  <Typography variant="h3" fontWeight="700" fontSize="16px" className="pl-2">
                    Technical Specification
                  </Typography>
                </Box>
                <Box sx={{ display: "flex", alignItems: "center", justifyContent: "flex-end" }}>
                  <Button
                    variant="text"
                    disabled={!accessPermissionAdd}
                    sx={{
                      backgroundColor: "transparent",
                      color: "#F94F5E !important",
                      fontSize: "16px",
                      textTransform: "none",
                      fontWeight: "400",
                      padding: "0 !important",
                      textAlign: "center",
                    }}
                    onClick={(event) => {
                      event.stopPropagation();
                      setTimeout(() => {
                        history.push(`${split_url.join("/")}/technical-specification/add#tech-spec`, {
                          companyId: props?.companyId,
                          productId: props?.productId,
                        });
                      }, 10);
                    }}
                  >
                    <AddIcon sx={{ color: "#F94F5E", width: "20px !important", height: "20px !important", marginRight: "2px !important" }} /> Add New
                  </Button>
                  {specificationData?.length > 0 && (
                    <Button
                      variant="text"
                      sx={{ minWidth: "0 !important", padding: "6px 8px !important" }}
                      onClick={() => handleAccordionChange("technicalSpecs")}
                    >
                      {expandedAccordions["technicalSpecs"] ? (
                        <KeyboardArrowUpOutlinedIcon sx={{ color: "#000", fontSize: "30px !important" }} />
                      ) : (
                        <KeyboardArrowDownOutlinedIcon sx={{ color: "#000", fontSize: "30px !important" }} />
                      )}
                    </Button>
                  )}
                </Box>
              </Box>
            </Box>
          </AccordionSummary>
          {expandedAccordions["technicalSpecs"] && (
            <AccordionDetails
              sx={{
                "& .form-group": {
                  marginBottom: "0 !important",
                },
              }}
            >
              <Box>
                <table className="normal-table table border">
                  <thead className="internal-grid">
                    <tr>
                      <th>Parameter Name</th>
                      <th>Unit of Measurement</th>
                      <th>Parameter Value</th>
                      <th className="text-center internal-grid-action" style={{ borderLeft: "1px solid #dee2e6" }}>
                        Action
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {specificationData?.map((item) => {
                      return (
                        <tr key={`tech-specs-${item.id}`}>
                          <td>{item?.specificationName}</td>
                          <td>{item?.specificationUnit || "--"}</td>
                          <td>
                            {item?.specificationValue?.max
                              ? item?.specificationValue?.min + ", " + item?.specificationValue?.max
                              : item?.specificationValue?.single || "--"}
                          </td>
                          <td className="text-center" style={{ borderLeft: "1px solid #dee2e6" }}>
                            {accessPermissionEdit || accessPermissionDelete ? (
                              <ThreeDotMenu
                                rowID={item.id}
                                Edit={
                                  accessPermissionEdit
                                    ? () => {
                                        history.push(`${split_url.join("/")}/technical-specification/${item.id}/edit#tech-specs`, {
                                          companyId: props?.companyId,
                                          productId: props?.productId,
                                          techSpecsId: item.id,
                                          item: item,
                                        });
                                      }
                                    : undefined
                                }
                                Delete={
                                  accessPermissionDelete
                                    ? () => {
                                        handleDeleteSpecification(item.id);
                                      }
                                    : undefined
                                }
                              />
                            ) : null}
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </Box>
            </AccordionDetails>
          )}
        </Accordion>
      </div>
      <div className="form-submit-box">
        <div className="footer-layout">
          {props.selectedIndex > 0 || props.selectedIndex === undefined ? (
            <button
              type="button"
              className="btn btn-outline-dark company-button"
              onClick={() => {
                (props.selectedIndex === undefined && props.setCurrentTab(3)) ||
                  (props.selectedIndex < 4 && props.setCurrentTab(props.selectedIndex - 1));
                s;
              }}
            >
              Previous
            </button>
          ) : null}
          {props.selectedIndex > -1 ? (
            <button
              type="button"
              className="btn btn-outline-dark company-button"
              onClick={() => {
                props.selectedIndex < 4 && props.setCurrentTab(props.selectedIndex + 1);
              }}
            >
              Next
            </button>
          ) : null}
        </div>
        {accessPermissionSubmit ? (
          <div className="footer-layout">
            <button
              type="button"
              onClick={(e) => {
                e.preventDefault();
                history.push(props.backPath, { companyId: props.companyId });
              }}
              className="btn btn-outline-dark company-button"
            >
              Cancel
            </button>
            <button
              type="button"
              className="btn btn-primary company-button"
              onClick={() => {
                dispatch(
                  showAlertBox({
                    okCallback: async () => {
                      props.onSaveProcessingData("tech_specificaion");
                    },
                    okText: "Submit",
                    cancelText: "Cancel",
                    content: "Are you sure you want to submit ?",
                    title: "dialogAlertCss",
                  })
                );
              }}
            >
              Submit
            </button>
          </div>
        ) : null}
      </div>
    </div>
  );
};

export default memo(TechnicalSpecs);
